import { TbChevronLeft } from 'react-icons/tb';
import type { MobileNavigationAccount, MobileNavigationMenu } from './types';
import MenuFooter from './MenuFooter';
import MenuLink from './MenuLink';
import MenuRow from './MenuRow';
import useMenuPath from './useMenuPath';

export interface MenuProps extends MobileNavigationMenu {
  account: MobileNavigationAccount | null;
}

export default function Menu({ items, account, support, engage }: MenuProps) {
  const { levelRef, current, parent, level, openBranch, goBack } =
    useMenuPath(items);

  return (
    <div ref={levelRef}>
      {current && (
        <h2 className="bio-mobile-menu__level-header">
          <button
            type="button"
            className="bio-mobile-menu__back"
            data-menu-back=""
            aria-label={
              parent ? `Back to ${parent.label}` : 'Back to main menu'
            }
            onClick={goBack}
          >
            <span className="bio-mobile-menu__back-icon" aria-hidden="true">
              <TbChevronLeft size={16} />
            </span>
            <span className="bio-mobile-menu__title">{current.label}</span>
          </button>
        </h2>
      )}
      <ul className="bio-mobile-menu__list">
        {current?.url && !current.heading && (
          <li className="bio-mobile-menu__item">
            <MenuLink item={current} label={`View ${current.label}`} />
          </li>
        )}
        {level.map((item) => (
          <MenuRow key={item.id} item={item} onOpen={openBranch} />
        ))}
      </ul>
      {!current && (
        <MenuFooter account={account} support={support} engage={engage} />
      )}
    </div>
  );
}
